import { render, staticRenderFns } from "./imgOrVideoDetail.vue?vue&type=template&id=58b1e65b&scoped=true"
import script from "./imgOrVideoDetail.vue?vue&type=script&lang=js"
export * from "./imgOrVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./imgOrVideoDetail.vue?vue&type=style&index=0&id=58b1e65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1e65b",
  null
  
)

export default component.exports